import {
    CircularProgress,
    Dialog

} from '@mui/material'

const CircularProgressPercent = ({ open, number }) => {
    return (
        <Dialog
            open={open}
            PaperProps={{
                style: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    height: 300,
                    width: 300
                }
            }}
        >
            <div style={{ backgroundColor: 'transparent', position: 'relative', height: 300, width: 300, overflow: 'hidden' }}>
                <CircularProgress variant={'determinate'} value={number} size={300} color={'primary'} />
                <img src="../assets/logo_icv_blanco.webp" width={150} style={{ position: 'absolute', top: 90, right: 70 }} />
            </div>
        </Dialog>
    )
}

export default CircularProgressPercent
